import { PrioritySelectDropdown } from "@/domain/priority/components/priority-select-dropdown";
import { useGetPriorityListForWorkspace } from "@/domain/priority/hooks/api/use-get-priority-list-for-workspace";

import { SelectFieldProps } from "./select-field-props";
import { SingletonSelectField } from "./singleton-select-field";

export function PrioritySelectField({ workspaceId, value, onChange, disabled }: SelectFieldProps) {
  const { priorityList } = useGetPriorityListForWorkspace({ workspaceId });

  return (
    <SingletonSelectField
      value={value}
      disabled={disabled}
      optionList={priorityList}
      renderDropdown={({ value: dropdownValue, disabled: dropdownDisabled, children }) => (
        <PrioritySelectDropdown
          workspaceId={workspaceId}
          selected={dropdownValue ? { priorityId: dropdownValue } : undefined}
          onSelect={(priority) => onChange(priority ? priority.id : "")}
          isReadOnly={dropdownDisabled}
          asChild
        >
          {children}
        </PrioritySelectDropdown>
      )}
    />
  );
}
